export const useSlideoutStore = defineStore('slideoutStore', {
  state: () => ({
    slideout: {
      id: '',
      props: {},
      component: null,
      title: '',
    },
  }),
  actions: {
    setSlideout(slideout) {
      this.slideout = slideout;
    },
  },
});
